/* eslint-disable */
import React, { PropTypes } from 'react'
import { Table, Column, Cell } from 'fixed-data-table';
import _ from 'lodash';
import $ from 'jquery';
import { browserHistory } from 'react-router';
import { DataListWrapper } from "../../../commonComponents/DataTable/DataTablePs";
import getObjByCategory from '../../../commonJS/getObjByCategory';
// import { DataListWrapper, SortTypes, SortHeaderCell, TextCell, NewsTypeCell, TimeWithoutHHmmssCell } from "../../../commonComponents/DataTable/DataTablePs";
// import custJqAjax from '../../../commonJS/custJqAjax';

export default class AdminDataTableCt extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      is_loading: true,
      all_data: [],
      name_sort: 'asc',
      color_sort: 'asc',
      fileproperty_sort: 'asc',
      category: getObjByCategory(props.route.category),
      fileproperty_data: [],
      width: 300,
      // is_reload: false,
      is_merge: false
    }

    this.loadData = this.loadData.bind(this);
  }

  componentDidMount() {

    this.setState({ width: document.getElementById('system_maintain').offsetWidth })
  }

  componentWillReceiveProps(nextProps) {

    const { name_sort, fileproperty_sort, category } = this.state
    let sort_data = []

    if (nextProps.route.category !== this.props.route.category) {

      switch (nextProps.route.category) {

        case 'FilePropertyValue':
          // is_merge is used to FilePropertyValue 
          this.setState({ category: getObjByCategory(nextProps.route.category), is_loading: true, is_merge: false })
          break;
        default:
          this.setState({ category: getObjByCategory(nextProps.route.category), is_loading: true })
          break;
      }
    }
    else if (nextProps.searchResults._data) {

      if (this.props.searchResults._data !== nextProps.searchResults._data) {

        sort_data = _.orderBy(nextProps.searchResults._data, ['name'], [name_sort])
      }
    }
    else if (nextProps.searchResults._data === undefined) {

      switch (category.name) {

        case 'FilePropertyValue':
          sort_data = _.orderBy(nextProps.filteredDataList._data, ['fileproperty_name'], [fileproperty_sort])
          break;
        default:
          sort_data = _.orderBy(nextProps.filteredDataList._data, ['name'], [name_sort])
          break;
      }
    }

    this.setState({ all_data: sort_data })
  }

  componentDidUpdate(prevProps, prevState) {

    const { all_data, fileproperty_data, category, is_loading, is_merge } = this.state

    if (is_loading === true) {

      this.loadData()
    }
    else if (is_loading === false && category.name === 'FilePropertyValue' && fileproperty_data.length === 0) {

      this.loadFilePropertyData()
    }
    else if (is_loading === false && is_merge === false && fileproperty_data.length !== 0) {

      let merge_data = all_data.map((x, y) => {

        let find_data = _.find(fileproperty_data, { id: x.fileproperty_id })
        x.fileproperty_name = find_data.name
        return x;
      })

      let defaultSortIndexes = [];
      let size = merge_data.length;
      for (let i = 0; i < size; i++) {
        defaultSortIndexes.push(i);
      }
      this.props.returnDataListToDashboardFunc(new DataListWrapper(defaultSortIndexes, merge_data), category.name);
      this.setState({ all_data: merge_data, is_merge: true })
    }
  }

  loadData() {

    const { category } = this.state

    $.ajax({
      type: 'get',
      url: category.get_url,
      success: response => {
        if (response.status === '0') {

          let result_data = response.result

          // 根據回傳欄位做統一設定
          switch (category.name) {

            case 'FormStatus':
              result_data.map((x, y) => {

                x.id = x.status_id
                x.name = x.status_name
                return x
              })
              break;
            case 'FormType':
              result_data.map((x, y) => {

                x.id = x.type_id
                x.name = x.type_name
                return x
              })
              break;
          }

          this.setState({ all_data: result_data, is_loading: false });

          let defaultSortIndexes = [];
          let size = result_data.length;
          for (let i = 0; i < size; i++) {
            defaultSortIndexes.push(i);
          }
          this.props.returnDataListToDashboardFunc(new DataListWrapper(defaultSortIndexes, result_data), category.name);
        }
        else alert(response.msg)
      },
      error: (xhr, ajaxOptions, thrownError) => { },
    });
  }

  loadFilePropertyData() {

    $.ajax({
      type: 'get',
      url: '/api/W_FileProperty_Get.php',
      success: response => {
        this.setState({ fileproperty_data: response.result });
      },
      error: (xhr, ajaxOptions, thrownError) => { },
    });
  }

  onRowClick(row) {
    const { category } = this.state

    browserHistory.push('/salesky/admin/' + category.name + '/' + row.id);
  }

  onSortChange(value, sort, sort_name) {

    const { all_data } = this.state

    let new_sort = sort === 'asc' ? 'desc' : 'asc'
    let sort_data = _.orderBy(all_data, [value], [new_sort])
    let new_state = {}
    new_state['all_data'] = sort_data
    new_state[sort_name] = new_sort
    this.setState(new_state)
  }

  renderColorCodeColumn() {

    const { all_data, color_sort, category } = this.state

    return (
      <Column
        width={300}
        flexGrow={1}
        cell={({ rowIndex, ...props }) => (
          <Cell {...props}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ backgroundColor: all_data[rowIndex]['color_code'], width: '30px', height: '30px', marginRight: '10px' }}></div>
              {all_data[rowIndex]['color_code']}
            </div>
          </Cell>
        )}
        header={
          <Cell>
            <a onClick={() => this.onSortChange('color_code', color_sort, 'color_sort')}
              style={{ textDecoration: "none", cursor: "pointer" }}>
              {category.column_color} {color_sort === 'asc' ? '↓' : '↑'}
            </a>
          </Cell>
        }
      />
    )
  }

  renderFilePropertyColumn() {

    const { all_data, fileproperty_sort, category } = this.state

    return (
      <Column
        width={300}
        flexGrow={1}
        cell={({ rowIndex, ...props }) => (
          <Cell {...props}>
            {all_data[rowIndex]['fileproperty_name']}
          </Cell>
        )}
        header={
          <Cell>
            <a onClick={() => this.onSortChange('fileproperty_name', fileproperty_sort, 'fileproperty_sort')}
              style={{ textDecoration: "none", cursor: "pointer" }}>
              {category.column_parent} {fileproperty_sort === 'asc' ? '↓' : '↑'}
            </a>
          </Cell>
        }
      />
    )
  }

  render() {
    const { closeModal, tableHeight } = this.props
    const { is_loading, all_data, name_sort, category, width } = this.state
    const loading = is_loading === true ? <div className="loading" style={{ maxWidth: category.width + 'px' }}><img role="presentation" src="/imgs/loading.gif" /></div> : false

    let modal = this.props.children ? React.cloneElement(this.props.children, {
      closeModal: closeModal,
      category: category.name,
      loadData: this.loadData,
      // rowItem: this.state.rowItem
    }) : "";

    let render_color_code_column = ''
    let render_file_property_column = ''

    if (is_loading === false) {
      render_color_code_column = category.name === 'UserGroup' ? this.renderColorCodeColumn() : ''
      render_file_property_column = category.name === 'FilePropertyValue' ? this.renderFilePropertyColumn() : ''
    }

    return (
      <div id="system_maintain" style={{ position: "relative" }}>
        {loading}
        <Table
          rowHeight={50}
          headerHeight={50}
          rowsCount={all_data.length}
          width={width}
          height={tableHeight || 477}
          onRowClick={(event, rowIndex) => this.onRowClick(all_data[rowIndex])} //onRowClick自帶三個props: event, rowIndex, Object
        // {...this.props}
        >
          {render_file_property_column}
          <Column
            width={300}
            flexGrow={1}
            cell={({ rowIndex, ...props }) => (
              <Cell {...props}>
                {all_data[rowIndex]['name']}
              </Cell>
            )}
            header={
              <Cell>
                <a onClick={() => this.onSortChange('name', name_sort, 'name_sort')}
                  style={{ textDecoration: "none", cursor: "pointer" }}>
                  {category.column_name} {name_sort === 'asc' ? '↓' : '↑'}
                </a>
              </Cell>
            }
          />
          {render_color_code_column}
        </Table>
        {modal}
      </div>
    )
  }
}

AdminDataTableCt.PropTypes = {
  filteredDataList: PropTypes.object.isRequired,
}





// WEBPACK FOOTER //
// ./src/salesky/routes/admin/AdminDataTable.jsx